import { forwardRef } from 'react';
// @mui
import Link from '@mui/material/Link';
import Box, { BoxProps } from '@mui/material/Box';
// routes
import { RouterLink } from 'src/routes/components';
import { useResponsive } from 'src/hooks/use-responsive';

// ----------------------------------------------------------------------

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
}

const LogoDark = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, sx, ...other }, ref) => {
    const isMobile = useResponsive('down', 'sm');

    const logo = (
      <Box
        ref={ref}
        component="img"
        sx={{
          width: 130,
          height: 45,
          display: 'inline-flex',
          ...sx,
        }}
        src="/logo/logo_full_dark.png"
        {...other}
      />
    );

    const singleLogo = (
      <Box
        ref={ref}
        component="img"
        sx={{
          width: 50,
          height: 50,
          display: 'inline-flex',
          ...sx,
        }}
        src="/logo/logo_single_dark.png"
        {...other}
      />
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link component={RouterLink} href="/" sx={{ display: 'contents' }}>
        {isMobile ? singleLogo : logo}
      </Link>
    );
  }
);

export default LogoDark;
